import { AvatarWithUsername } from '@tryhackme/thm-ui-components';
import { UserOccupation } from '../../user-occupation';
import { UserOccupationProps } from '../../user-occupation.types';
const columns: UserOccupationProps['columns'] = [{
  key: 'username',
  title: 'Username',
  flex: '0 0 25%',
  sortFunction: () => null,
  render: (item, row) => <AvatarWithUsername username={item} avatar={row.avatar} />
}, {
  key: 'fullName',
  title: 'Full Name',
  flex: '0 0 19%',
  sortFunction: () => null
}, {
  key: 'email',
  title: 'Email',
  flex: '0 0 25%',
  sortFunction: () => null
}, {
  key: 'occupation',
  title: 'Occupation',
  flex: '0 0 14%',
  sortFunction: () => null
}, {
  key: 'jobTitle',
  title: 'Job Title',
  flex: '0 0 18%',
  sortFunction: () => null
}, {
  key: 'institutionName',
  title: 'Institution Name',
  flex: '0 0 20%',
  sortFunction: () => null
}, {
  key: 'institutionType',
  title: 'Institution Type',
  flex: '0 0 15%',
  sortFunction: () => null
}, {
  key: 'companyId',
  title: 'Company Id',
  sortFunction: () => null,
  flex: '0 0 20%'
}, {
  key: 'team',
  title: 'Team',
  flex: '0 0 15%',
  sortFunction: () => null
}, {
  key: 'phoneNumber',
  title: 'Phone Number',
  flex: '0 0 15%',
  sortFunction: () => null
}];
export const Users = () => <UserOccupation title="User Occupation Details" columns={columns} data-sentry-element="UserOccupation" data-sentry-component="Users" data-sentry-source-file="users.tsx" />;